import { useState, useEffect } from "react";
import { fetchDashboardCountsAction } from "../../../../actions/tatDashboardGraphActions";

/**
 * Maps the API response fields to the chart-friendly label/value/color shape.
 */
const mapToChartData = (data = {}) => [
  {
    label: "Service Partner",
    value: data.servicePartnerPendingCount ?? 0,
    // value: 2022,
    color: "#3b82f6", // blue
  },
  {
    label: "Client",
    value: data.clientPendingCount ?? 0,
    color: "#3b82f6", // blue
  },
  {
    label: "Authorizer",
    value: data.authorizerPendingCount ?? 0,
    color: "#3b82f6", // blue
  },
];

export const useTatGraphData = () => {
  const [chartData, setChartData] = useState(mapToChartData());
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      setLoading(true);
      setError(null);
      try {
        const result = await fetchDashboardCountsAction();
        if (!cancelled) {
          if (result.success) {
            setChartData(mapToChartData(result.data));
          } else {
            setError(result.message || "Failed to load chart data");
          }
        }
      } catch (err) {
        if (!cancelled) setError("Failed to load chart data");
      } finally {
        if (!cancelled) setLoading(false);
      }
    };

    load();
    return () => {
      cancelled = true;
    };
  }, []);

  return { chartData, loading, error };
};
